import React from 'react';
import { useGlobalContext } from '../../context';
import Loading from '../loading/Loading';
import TripListCard from '../trip_list_card/TripListCard';
import './TripList.css';

function TripList() {
  const {isLoadingTripList, tripList, departureLocation} = useGlobalContext();

  return (
    <section>
      <p>Here are the possible trips from {departureLocation}</p>
      <p>Click on one to select before confirming at the next step</p>
      {isLoadingTripList ? <Loading/> :
        <div className='trip-list-container'>
          {tripList.map((trip) => {
            return (
              <TripListCard key={trip.id} trip={trip} />
            )
          })}
        </div>
      }
    </section>
  )
}

export default TripList
